var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp, _initialiseProps;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { Button, Form, FormGroup, FormFeedback, Label, Input, InputGroup, InputGroupAddon, InputGroupText, CustomInput, Modal, ModalHeader, ModalBody, ModalFooter, Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import { Card, CardTitle, CardText, CardBody, Row, Col, Container } from 'reactstrap';

import RXInlineFormGroup from './RXInlineFormGroup';
import { RXInputList } from './RXInputList';
import RXInputGroup from './RXInputGroup';
import RXInput from './RXInput';

import { validatorRequired } from './RXValidators';
import { createStore } from 'redux';
import { FormActions, FormStates, FormReducer } from './RXFormEvents';

var logdown = require('logdown');
var console = logdown('rx-forms', { prefixColor: '#FF0000' });
import update from 'immutability-helper';

export var RXForm = (_temp = _class = function (_Component) {
    _inherits(RXForm, _Component);

    function RXForm(props) {
        _classCallCheck(this, RXForm);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _initialiseProps.call(_this);

        var formData = {};
        _this.props.model.groups.map(function (group, index) {

            if (Array.isArray(group)) {
                group.map(function (input) {
                    console.log('fix default for ', input);
                    if (group.type === 'checkbox' || group.type === 'switch') {
                        formData[input.name] = false;
                    } else if (input.type === 'number') {
                        console.log('fix number');
                        formData[input.name] = 0;
                    } else {
                        formData[input.name] = "";
                    }
                });
            } else if (group.type == "group") {
                group.inputs.map(function (input) {
                    if (input.type === 'checkbox' || group.type === 'switch') {
                        formData[input.name] = false;
                    } else if (input.type === 'number') {
                        console.log('fix number for group');
                        formData[input.name] = 0;
                    } else {
                        formData[input.name] = "";
                    }
                });
            } else {
                if (group.type === 'checkbox' || group.type === 'switch') {
                    formData[group.name] = false;
                } else if (group.type === 'number') {
                    formData[group.name] = 0;
                } else {
                    formData[group.name] = "";
                }
            }
        });

        console.log('after initialize formData: ', formData);

        //create store for submit validation
        _this.formstore = createStore(FormReducer);

        console.log('*before initialize validators*');
        var validators = {
            required: validatorRequired
        };

        //add custom validators
        if (_this.props.validators !== undefined) {
            validators = Object.assign(validators, _this.props.validators);
            console.log('after customValidators: ' + validators['required']);
        }

        var placeholders = [];
        if (_this.props.placeholders !== undefined) {
            placeholders = _this.props.placeholders;
        }
        console.log('log placeholders: ' + JSON.stringify(_this.props.placeholders));

        _this.state = {
            formData: _this.props.initialValues ? _this.props.initialValues : formData, //TODO: Qua potrebbe volerci un merge
            validators: validators,
            placeholders: placeholders,
            errors: {},
            row: _this.props.model.type && _this.props.model.type == 'row' ? true : false
        };

        console.log('log formData: ' + JSON.stringify(_this.state.formData));

        return _this;
    }

    RXForm.prototype.componentDidMount = function componentDidMount() {
        var _this2 = this;

        console.log('onLoad for RXForm - try to get initialValues');
        console.log('log values for form ##' + this.props.model.name + '##: ' + JSON.stringify(this.props.initialValues));

        if (this.props.initialValues !== undefined) {
            this.setState(function (prevState) {
                var formData = prevState.formData;
                Object.keys(_this2.props.initialValues).map(function (key, index) {

                    formData[key] = _this2.props.initialValues[key];
                });

                return { formData: formData };
            }, function () {
                return console.log('after setupFormData: ', _this2.state.formData);
            });
        }
    };

    RXForm.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
        var _this3 = this;

        if (this.props.initialValues != prevProps.initialValues) {
            console.log('1212 try to change initialValues with componentDidUpdate with prev: ', this.state.formData, ' and next ', this.props.initialValues);

            this.setState(function (prevState) {
                return { formData: update(prevState.formData, { $merge: _this3.props.initialValues }) };
            }, function () {
                return console.log('1212 new state: ', _this3.state.formData);
            });

            // this.setState((prevState)=> {
            //     var initialValues = prevState.formData;
            //     Object.keys(this.props.initialValues).map((key, index)=>{

            //         initialValues[key] = this.props.initialValues[key];
            //     })
            //     console.log(`new formValue: `, initialValues);
            //     return { formData: initialValues };
            // });
        }
    };

    RXForm.prototype.render = function render() {
        var _this4 = this;

        console.log('in render for RXForm: ' + JSON.stringify(this.state));

        var formLayout = "standard";
        if (this.props.model.layout == "grid") {
            formLayout = "grid";
        }

        return React.createElement(
            Form,
            { onKeyPress: this.onKeyPress },
            this.props.model.groups.map(function (group, index) {

                console.log('in render for group: ', group, ' with ', _this4.state.formData);

                if (Array.isArray(group)) {
                    return React.createElement(RXInlineFormGroup, { events: _this4.props.events, key: index, group: group, parentOnChange: _this4.onChange, formvalidators: _this4.state.validators, formData: _this4.state.formData, errors: _this4.state.errors, formstore: _this4.formstore, transformers: _this4.props.transformers });
                } else if (group.type === "group") {

                    return React.createElement(
                        React.Fragment,
                        { key: index },
                        group.inputs.map(function (element, innerIndex) {

                            var validators = element.validators === undefined ? [] : element.validators;

                            return React.createElement(RXInput, { key: innerIndex, label: element.label, type: element.type, value: _this4.state.formData[group.name], onChange: _this4.onChange, name: element.name, id: element.name, formvalidators: _this4.state.validators, validators: validators, errors: _this4.state.errors, formstore: _this4.formstore, transformers: _this4.props.transformers });
                        })
                    );
                } else if (group.type === "list") {

                    return React.createElement(RXInputList, { key: index, group: group, parentOnChange: _this4.onChange, formvalidators: _this4.state.validators, placeholders: _this4.state.placeholders, formData: _this4.state.formData, errors: _this4.state.errors, formstore: _this4.formstore, transformers: _this4.props.transformers });
                } else {
                    console.log('in RXForm render log addons: ' + JSON.stringify(group.addons));
                    var hasAddons = group.addons !== undefined;
                    var validators = group.validators === undefined ? [] : group.validators;
                    console.log('in RXForm render log group.label: ' + JSON.stringify(group.label));
                    return React.createElement(
                        FormGroup,
                        { key: index, row: _this4.state.row },
                        group.type !== "checkbox" && (group.noLabel == undefined || group.noLabel == false) && React.createElement(
                            Label,
                            { 'for': group.name, sm: 2 },
                            group.label
                        ),
                        _this4.state.row ? React.createElement(
                            Col,
                            { sm: 10 },
                            hasAddons ? React.createElement(RXInputGroup, { events: _this4.props.events, group: group, parentOnChange: function parentOnChange(e) {
                                    console.log('Inputgroup1');_this4.onChange(e);
                                }, formvalidators: _this4.state.validators, placeholders: _this4.state.placeholders, formData: _this4.props.initialValues, errors: _this4.state.errors, formstore: _this4.formstore, transformers: _this4.props.transformers }) : React.createElement(
                                'div',
                                { style: { position: "relative" } },
                                React.createElement(RXInput, _extends({ label: group.label, type: group.type, value: _this4.state.formData[group.name], onChange: _this4.onChange, name: group.name, id: group.name, formvalidators: _this4.state.validators, validators: validators, errors: _this4.state.errors, formstore: _this4.formstore, transformers: _this4.props.transformers }, group))
                            )
                        ) : React.createElement(
                            'span',
                            null,
                            hasAddons ? React.createElement(RXInputGroup, { events: _this4.props.events, group: group, parentOnChange: function parentOnChange(e) {
                                    console.log('Inputgroup2');_this4.onChange(e);
                                }, formvalidators: _this4.state.validators, placeholders: _this4.state.placeholders, formData: _this4.props.initialValues, errors: _this4.state.errors, formstore: _this4.formstore, transformers: _this4.props.transformers }) : React.createElement(
                                'div',
                                { style: { position: "relative" } },
                                React.createElement(RXInput, _extends({ label: group.label, type: group.type, value: _this4.state.formData[group.name], onChange: _this4.onChange, onFileAdded: _this4.onFileAdded, name: group.name, id: group.name, formvalidators: _this4.state.validators, validators: validators, errors: _this4.state.errors, formstore: _this4.formstore, transformers: _this4.props.transformers }, group))
                            )
                        )
                    );
                }
            }),
            this.props.model.submit !== undefined && React.createElement(
                Button,
                { color: this.props.model.submit.color, style: { marginTop: 16 }, block: true, size: 'lg', onClick: this.onSubmit },
                this.props.model.submit.title
            )
        );
    };

    return RXForm;
}(Component), _initialiseProps = function _initialiseProps() {
    var _this5 = this;

    this.onChange = function (event) {

        console.log('log event onChange: ', event);
        var value;

        switch (event.target.type) {
            case "checkbox":
            // value = event.target.checked;
            // break;
            case "switch":
                value = event.target.value;
                break;
            case "select":
                if (event.target.value === undefined || event.target.value === null) {
                    value = { label: "", value: 0 };
                } else {
                    value = event.target.value;
                }
                break;
            case "number":
                console.log('in onChange for number with ', event.target.value);
                value = event.target.value;
                value = value == "" || value == "undefined" ? Number(0) : Number(value);
                break;
            default:
                console.log('in onChange with type undefined');
                value = event.target.value;
                break;
        }
        // const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        // console.log(`in RXForm onchange with event ${value} and target: ${event.target.id}`);

        var val = value;
        var id = event.target.id;

        _this5.props.onFieldValueChange(id, value);

        _this5.setState(function (prevState) {
            var formData = prevState.formData;
            formData[id] = val;

            return { formData: formData };
        });
    };

    this.onSubmit = function (event) {
        console.log('in onsubmit with validate: ' + _this5.props.validate);
        event.preventDefault();
        if (_this5.props.validate) {
            _this5.validate();
        }
        var formData = _extends({ errors: _this5.state.errors }, _this5.state.formData);
        _this5.props.onSubmit(formData, _this5.state.errors);
    };

    this.validate = function () {
        console.log('in force validate for form');
        _this5.setState({ errors: {} });
        _this5.formstore.dispatch({
            type: FormActions.VALIDATE
        });
    };

    this.submit = function () {
        var validate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var sync = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        if (validate) {
            _this5.validate();
        }
        var formData = _extends({ errors: _this5.state.errors }, _this5.state.formData);

        if (sync) {
            return formData;
        } else {
            _this5.props.onSubmit(formData, _this5.state.errors);
        }
    };

    this.onKeyPress = function (event) {
        if (event.which === 13 /* Enter */) {
                event.preventDefault();
            }
    };

    this.onFileAdded = function (event) {

        console.log('in onFileAdded with event: ', event);
        if (_this5.props.onFileAdded) {
            _this5.props.onFileAdded(event);
        }
    };
}, _temp);
RXForm.defaultProps = {
    onFieldValueChange: function onFieldValueChange(i, v) {},
    events: {},
    transformers: {}
    // export default RXForm

};